module.exports = __webpack_public_path__ + "img/date.e665aa2f.svg";